import React from 'react'
import { TableRow } from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import { useHistory } from 'react-router-dom'
import Chip from '@material-ui/core/Chip'
import { Types } from '../../store/constants/fonction/fonction'
import { TableExtensions } from '../../dsn-kernel/table/TableExtensions'

export const ListeFonctions = ({ items, filterBy }) => {
  const history = useHistory()
  return (
    <Paper>
      <TableExtensions
        search={filterBy}
        items={items}
        headCells={[
          {
            id: 'nom',
            label: 'Nom',
            filter: true,
          },
          {
            id: 'type',
            label: 'Type',
          },
          {
            id: 'description',
            label: 'Description',
            filter: true,
          },
          {
            id: 'tags',
            label: 'Tags',
            filter: true,
          },
          {
            id: 'exemple',
            label: 'Exemple',
          },
        ]}
        renderTableBody={list =>
          list.map((item, idx) => (
            <TableRow key={idx}>
              <TableCell>
                <Link href="#" onClick={() => history.push(`/fonction/edit/${item.nom}`)}>
                  {item.nom}
                </Link>
              </TableCell>
              <TableCell>
                {Types[item.type]?.label}
                {Types[item.type] === Types.REFERENCE ? ` [${item.reference}]` : ''}
              </TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>
                {item.tags.map((tag, index) => (
                  <Chip key={index} label={tag} size="small" />
                ))}
              </TableCell>
              <TableCell>{item.exemple}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          ))
        }
      />
    </Paper>
  )
}
